import type { ReactNode } from 'react'
import { PublicHeader } from '@/components/navigation/PublicHeader'
import { AppFooter } from '@/components/layout/AppFooter'
import { WorkspaceFooter } from '@/components/layout/WorkspaceFooter'
import { ConsentBanner } from '@/components/consent/ConsentBanner'
import type { PublicMode } from '@/components/navigation/publicNav'
import styles from './PublicShell.module.css'

type Props = {
  children: ReactNode
  /** Resolved by resolveChrome — marketing (B2B/brand), player (marketplace),
   *  or auth (logo-only). App-signed-in routes keep the sidebar AppShell. */
  mode: PublicMode
}

/**
 * The front-of-house shell (site-relaunch Wave 1): a fixed two-mode public
 * header over a centered content column + the shared footer. Replaces the
 * sidebar AppShell for marketing/player/auth routes; the signed-in app keeps its
 * sidebar/drawer shell. The scan-line backdrop matches the app's non-admin tone.
 *
 * No page wears the animated court any more (owner, 2026-09-23 home split: "the court
 * with the ball in the background: let's remove it" — from every marketing page). The
 * heroes sit on the page background and the scan lines, and the fixed header blurs
 * what scrolls beneath it everywhere.
 */
export function PublicShell({ children, mode }: Props) {
  return (
    <div className={styles.shell}>
      <a href="#main-content" className={styles.skipLink}>
        Skip to content
      </a>
      <div className={styles.scanlines} aria-hidden="true" />
      <div className={styles.content}>
        <PublicHeader mode={mode} />
        <main id="main-content" className={`container ${styles.main}`}>
          {children}
        </main>
        {/* THE SITE FOOTER IS THE MARKETING SITE'S (owner, 2026-09-07). Three
            columns selling the platform belong on the pages that exist to sell
            it; a player surface is the product, and it gets the compact footer
            the workspace already uses — the whole of it, and nothing added.
            The same day, the owner struck the slim row of marketing links this
            call used to pass in: "убрать, оставить только powered by
            TheRacketCenter.com", accepting that /pricing, /solutions, /guides
            and /about lose their inbound link from our busiest public pages.
            So a player surface now gets exactly what the workspace gets. Auth
            pages are untouched. */}
        {mode === 'player' ? <WorkspaceFooter /> : <AppFooter />}
      </div>
      <ConsentBanner />
    </div>
  )
}
